import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {HelperService} from "../services/helper.service";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  public  isLogged: any = false;

  constructor(
      private helperService: HelperService,
      private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.isLogged = this.authenticationService.isLogged();
  }

  goToHome(){
      if(this.isLogged){
        this.helperService.goBack();
      }else{
        this.helperService.go('pages/login');
      }

  }
}



// WEBPACK FOOTER //
// /app/src/app/privacy-policy/privacy-policy.component.ts